import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Inline field-level error used across every form.
 * Renders nothing when `msg` is falsy. When set, shows a small red line
 * with an icon directly beneath the associated input.
 *
 * Keep this dumb — all text should already be translated by the caller
 * (so the calling component can use its own useLanguage context).
 */
const FieldError = ({ msg, 'data-testid': testId }) => {
  if (!msg) return null;
  return (
    <p
      data-testid={testId}
      className="mt-1 text-xs text-red-500 flex items-center gap-1 leading-tight"
    >
      <AlertCircle className="h-3 w-3 flex-shrink-0" />
      <span>{msg}</span>
    </p>
  );
};

export default FieldError;
